module.exports = __webpack_public_path__ + "media/images/icon_date-1a510322bb91951b7720d28faa4f8bf3.png";